import { createContext, useContext, useState } from "react";
import Toast from "../hooks/Toast";

const AlertContext = createContext();

export function AlertProvider({ children }) {
  const [alerts, setAlerts] = useState([]);

  const showAlert = (msg, duration = 1500) => {
    const id = Date.now();
    setAlerts((prev) => [...prev, { id, msg, duration }]);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}

      {alerts.map((a) => (
        <Toast
          key={a.id}
          message={a.msg}
          duration={a.duration}
          onClose={() =>
            setAlerts((prev) => prev.filter((alert) => alert.id !== a.id))
          }
        />
      ))}
    </AlertContext.Provider>
  );
}

export const useAlert = () => useContext(AlertContext);
